"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _seed = _interopRequireDefault(require("antd/es/theme/themes/seed"));
var _tokenMeta = _interopRequireDefault(require("antd/lib/version/token-meta.json"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _useDebouncy = require("use-debouncy");
var _ColorPicker = _interopRequireDefault(require("../ColorPicker"));
var _context = require("../context");
var _useControlledTheme = require("../hooks/useControlledTheme");
var _icons2 = require("../icons");
var _locale = require("../locale");
var _constants = require("../utils/constants");
var _getDesignToken = _interopRequireDefault(require("../utils/getDesignToken"));
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _InputNumberPlus = _interopRequireDefault(require("./InputNumberPlus"));
var _ResetTokenButton = _interopRequireDefault(require("./ResetTokenButton"));
var _TokenPreview = _interopRequireDefault(require("./TokenPreview"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Panel = _antd.Collapse.Panel;
var useStyle = (0, _makeStyle.default)('ColorTokenContent', function (token) {
  return {
    '.token-panel-pro-color': (0, _defineProperty2.default)({
      height: 'auto',
      display: 'flex',
      '.token-panel-pro-color-seeds': {
        height: '100%',
        flex: 1,
        width: 0,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        borderBottom: "1px solid ".concat(token.colorBorderSecondary),
        '.token-panel-pro-color-themes': {
          display: 'flex',
          alignItems: 'center',
          padding: '0 16px',
          flex: '0 0 60px',
          borderBlockEnd: "1px solid ".concat(token.colorBorderSecondary),
          color: token.colorText,
          fontWeight: token.fontWeightStrong,
          '> span': {
            fontSize: token.fontSizeLG
          }
        }
      },
      '.token-panel-pro-token-list': (0, _defineProperty2.default)((0, _defineProperty2.default)({
        flex: 1,
        overflow: 'auto',
        '.token-panel-pro-token-item': (0, _defineProperty2.default)({
          display: 'flex',
          flexWrap: 'wrap',
          '&-seed': {
            width: '100%',
            padding: '18px 18px 8px 14px'
          }
        }, "&:not(:last-child)", {
          borderBlockEnd: "1px solid ".concat(token.colorBorderSecondary)
        }),
        '.token-panel-pro-token-item-header': {
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          width: '100%',
          '> *': {
            marginBottom: 10
          },
          '.token-panel-pro-token-item-header-title': {
            marginInlineEnd: 4,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight,
            color: token.colorText
          },
          '&-follow-primary': {
            marginLeft: 'auto',
            fontSize: 12,
            display: 'flex',
            alignItems: 'center',
            color: token.colorText
          }
        },
        '.token-panel-pro-token-list-description': {
          color: token.colorTextTertiary,
          marginBottom: 16
        },
        '.token-panel-pro-token-list-subtitle': {
          color: token.colorTextSecondary,
          fontSize: 12
        },
        '.token-panel-pro-token-list-seed-block': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          '+ .token-panel-pro-token-list-seed-block': {
            marginTop: 12
          },
          '&-name-cn': {
            fontSize: token.fontSize,
            fontWeight: token.fontWeightStrong,
            marginInlineEnd: 4,
            color: token.colorText
          },
          '&-subtitle': {
            fontSize: token.fontSizeSM,
            color: token.colorTextTertiary,
            marginInlineEnd: 4
          },
          '&-sample': {
            flex: 'none',
            position: 'relative',
            '&:not(:last-child)': {
              marginInlineEnd: 16
            },
            '&-theme': {
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: -8,
              margin: 'auto',
              transform: 'translateX(-100%)',
              height: 22
            },
            '&-card': {
              cursor: 'pointer',
              border: "1px solid ".concat(token.colorBorderSecondary),
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '6px 8px',
              '&-value': {
                fontFamily: 'Monaco,Monospace'.concat(token.fontFamily),
                fontSize: 14,
                color: token.colorTextSecondary
              }
            }
          }
        }
      }, ".token-panel-pro-token-list-map-collapse".concat(token.rootCls, "-collapse"), (0, _defineProperty2.default)({
        borderRadius: 0,
        borderTop: "1px solid ".concat(token.colorBorderSecondary)
      }, "> ".concat(token.rootCls, "-collapse-item"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "> ".concat(token.rootCls, "-collapse-header"), (0, _defineProperty2.default)({
        padding: "8px 15px",
        color: token.colorTextSecondary
      }, "> ".concat(token.rootCls, "-collapse-expand-icon"), {
        paddingInlineEnd: 4
      })), '.token-panel-pro-token-list-map-collapse-grouped', {
        opacity: 0,
        pointerEvents: 'none',
        transition: 'opacity 0.2s',
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        justifyContent: 'flex-end',
        color: token.colorTextTertiary
      }), "&".concat(token.rootCls, "-collapse-item-active"), {
        '.token-panel-pro-token-list-map-collapse-grouped': {
          opacity: 1,
          pointerEvents: 'auto'
        }
      }))), ".token-panel-pro-token-collapse-map", {
        borderRadius: 0,
        backgroundColor: token.colorBgContainer,
        border: "1px solid ".concat(token.colorSplit),
        paddingLeft: 12,
        fontSize: 12,
        '&:not(:last-child)': {
          borderBottom: 'none'
        },
        '.token-panel-pro-token-collapse-map-collapse-token': {
          color: token.colorTextSecondary,
          marginInlineStart: 4,
          marginInlineEnd: 8
        },
        '.token-panel-pro-token-collapse-map-collapse-preview': {
          display: 'flex',
          flex: 'none',
          borderLeft: "1px solid ".concat(token.colorSplit),
          cursor: 'pointer',
          '.token-panel-pro-token-collapse-map-collapse-preview-color': {
            height: 40,
            width: 40,
            position: 'relative'
          }
        }
      }),
      '.token-panel-pro-token-collapse-map-collapse-count': {
        color: token.colorTextTertiary,
        display: 'inline-block',
        fontSize: 12,
        lineHeight: '16px',
        padding: '0 6px',
        backgroundColor: token.colorFillTertiary,
        borderRadius: 4,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginLeft: 'auto',
        marginRight: 12,
        maxWidth: 100,
        flex: 'none',
        whiteSpace: 'nowrap',
        cursor: 'pointer'
      },
      '.token-panel-pro-token-pick': {
        transition: 'color 0.3s'
      },
      '.token-panel-pro-token-picked': {
        color: token.colorPrimary
      }
    }, ".token-panel-pro-grouped-map-collapse".concat(token.rootCls, "-collapse"), (0, _defineProperty2.default)({
      borderRadius: "4px 4px 0 0"
    }, "> ".concat(token.rootCls, "-collapse-item"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "&:last-child", {
      borderRadius: 0
    }), "> ".concat(token.rootCls, "-collapse-header"), (0, _defineProperty2.default)({
      padding: '6px 12px',
      color: token.colorIcon,
      fontSize: 12,
      lineHeight: token.lineHeightSM
    }, "".concat(token.rootCls, "-collapse-expand-icon"), {
      lineHeight: '20px',
      height: 20
    })), "> ".concat(token.rootCls, "-collapse-content > ").concat(token.rootCls, "-collapse-content-box"), {
      padding: 0,
      '.token-panel-pro-token-collapse-map': {
        borderInline: 0,
        '&:last-child': {
          borderBottom: 0
        },
        '&:first-child': {
          borderTop: 0
        }
      }
    })))
  };
});
var getSeedValue = function getSeedValue(config, token) {
  var _config$token;
  // @ts-ignore
  return ((_config$token = config.token) === null || _config$token === void 0 ? void 0 : _config$token[token]) || _seed.default[token] || (0, _getDesignToken.default)(config)[token];
};
var seedRange = {
  borderRadius: {
    min: 0,
    max: 16
  },
  fontSize: {
    min: 12,
    max: 32
  },
  sizeStep: {
    min: 0,
    max: 16
  },
  sizeUnit: {
    min: 0,
    max: 16
  },
  margin: {
    min: 0,
    max: 32
  },
  padding: {
    min: 0,
    max: 32
  }
};
var SeedTokenPreview = function SeedTokenPreview(_ref) {
  var theme = _ref.theme,
    tokenName = _ref.tokenName,
    disabled = _ref.disabled,
    children = _ref.children;
  var _useState = (0, _react.useState)(getSeedValue(theme.config, tokenName)),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    tokenValue = _useState2[0],
    setTokenValue = _useState2[1];
  var onThemeChange = function onThemeChange(newValue) {
    var _theme$onThemeChange;
    (_theme$onThemeChange = theme.onThemeChange) === null || _theme$onThemeChange === void 0 || _theme$onThemeChange.call(theme, _objectSpread(_objectSpread({}, theme.config), {}, {
      token: _objectSpread(_objectSpread({}, theme.config.token), {}, (0, _defineProperty2.default)({}, tokenName, newValue))
    }), ['token', tokenName]);
  };
  var debouncedOnChange = (0, _useDebouncy.useDebouncyFn)(onThemeChange, 200);
  var handleChange = function handleChange(value) {
    setTokenValue(value);
    debouncedOnChange(value);
  };
  (0, _react.useEffect)(function () {
    setTokenValue(getSeedValue(theme.config, tokenName));
  }, [theme.config, tokenName]);
  var tokenGroup = ['fontSize', 'sizeUnit', 'sizeStep', 'borderRadius', 'margin', 'padding'].find(function (prefix) {
    return tokenName.startsWith(prefix);
  });
  var nonColorInput = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tokenGroup && /*#__PURE__*/_react.default.createElement(_InputNumberPlus.default, {
    value: tokenValue,
    onChange: handleChange,
    min: seedRange[tokenGroup].min,
    max: seedRange[tokenGroup].max
  }), ['boxShadow', 'lineHeight'].some(function (prefix) {
    return tokenName.startsWith(prefix);
  }) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Input.TextArea, {
    value: tokenValue,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return handleChange(value);
    },
    style: {
      width: 200
    }
  })), tokenName === 'wireframe' && /*#__PURE__*/_react.default.createElement(_antd.Switch, {
    checked: tokenValue,
    onChange: handleChange
  }));
  if (children) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tokenName.startsWith('color') ? /*#__PURE__*/_react.default.createElement(_ColorPicker.default, {
      onChangeComplete: function onChangeComplete(newColor) {
        return onThemeChange(newColor.toHexString());
      },
      value: tokenValue
    }, children) : /*#__PURE__*/_react.default.createElement(_antd.Popover, {
      arrow: false,
      placement: "bottomRight",
      trigger: "click",
      content: nonColorInput
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-token-list-seed-block-sample"
  }, tokenName.startsWith('color') && /*#__PURE__*/_react.default.createElement(_ColorPicker.default, {
    onChangeComplete: function onChangeComplete(newColor) {
      return onThemeChange(newColor.toHexString());
    },
    value: tokenValue
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-token-list-seed-block-sample-card",
    style: {
      pointerEvents: disabled ? 'none' : 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundColor: tokenValue,
      width: 48,
      height: 32,
      borderRadius: 6,
      marginRight: 10,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.09)'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-token-list-seed-block-sample-card-value"
  }, tokenValue))), nonColorInput);
};
var MapTokenCollapseContent = function MapTokenCollapseContent(_ref3) {
  var mapTokens = _ref3.mapTokens,
    theme = _ref3.theme,
    type = _ref3.type;
  var locale = (0, _locale.useLocale)();
  var getMapTokenColor = function getMapTokenColor(token) {
    var _theme$config$token;
    return !!((_theme$config$token = theme.config.token) !== null && _theme$config$token !== void 0 && _theme$config$token[token]) ? _constants.HIGHLIGHT_COLOR : '';
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, mapTokens === null || mapTokens === void 0 ? void 0 : mapTokens.map(function (mapToken) {
    var _mapToken;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "token-panel-pro-token-collapse-map",
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      key: mapToken
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 1,
        whiteSpace: 'nowrap',
        width: 0,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        marginRight: 8
      }
    }, locale._lang === 'zh-CN' && /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontWeight: 500,
        flex: 'none',
        color: getMapTokenColor(mapToken)
      }
    }, (_mapToken = _tokenMeta.default.global[mapToken]) === null || _mapToken === void 0 ? void 0 : _mapToken.name), /*#__PURE__*/_react.default.createElement("span", {
      className: "token-panel-pro-token-collapse-map-collapse-token",
      style: {
        flex: 'none',
        color: getMapTokenColor(mapToken)
      }
    }, mapToken), /*#__PURE__*/_react.default.createElement(_ResetTokenButton.default, {
      theme: theme,
      tokenName: mapToken
    })), /*#__PURE__*/_react.default.createElement("span", {
      title: (0, _getDesignToken.default)(theme.config)[mapToken],
      className: "token-panel-pro-token-collapse-map-collapse-count"
    }, (0, _getDesignToken.default)(theme.config)[mapToken]), /*#__PURE__*/_react.default.createElement(SeedTokenPreview, {
      theme: theme,
      tokenName: mapToken
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "token-panel-pro-token-collapse-map-collapse-preview"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "token-panel-pro-token-collapse-map-collapse-preview-color"
    }, /*#__PURE__*/_react.default.createElement(_TokenPreview.default, {
      theme: theme.config,
      tokenName: mapToken,
      type: type
    })))));
  }));
};
var MapTokenCollapse = function MapTokenCollapse(_ref4) {
  var _group$mapToken2;
  var theme = _ref4.theme,
    onTokenSelect = _ref4.onTokenSelect,
    selectedTokens = _ref4.selectedTokens,
    groupFn = _ref4.groupFn,
    group = _ref4.group;
  var locale = (0, _locale.useLocale)();
  var groupedTokens = (0, _react.useMemo)(function () {
    var grouped = {};
    if (groupFn) {
      var _group$mapToken;
      (_group$mapToken = group.mapToken) === null || _group$mapToken === void 0 || _group$mapToken.forEach(function (token) {
        var _groupFn, _grouped$key;
        var key = (_groupFn = groupFn(token)) !== null && _groupFn !== void 0 ? _groupFn : 'default';
        grouped[key] = [].concat((0, _toConsumableArray2.default)((_grouped$key = grouped[key]) !== null && _grouped$key !== void 0 ? _grouped$key : []), [token]);
      });
    }
    return grouped;
  }, [group, groupFn]);
  if (groupFn) {
    var _group$mapTokenGroups;
    return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
      className: "token-panel-pro-grouped-map-collapse",
      defaultActiveKey: Object.keys(groupedTokens),
      expandIconPosition: "end",
      expandIcon: function expandIcon(_ref5) {
        var isActive = _ref5.isActive;
        return /*#__PURE__*/_react.default.createElement(_icons.CaretRightOutlined, {
          rotate: isActive ? 450 : 360,
          style: {
            fontSize: 12
          }
        });
      }
    }, ((_group$mapTokenGroups = group.mapTokenGroups) !== null && _group$mapTokenGroups !== void 0 ? _group$mapTokenGroups : Object.keys(groupedTokens)).map(function (key) {
      var _key;
      return /*#__PURE__*/_react.default.createElement(Panel, {
        key: key,
        header: (_key = locale[key]) !== null && _key !== void 0 ? _key : ''
      }, /*#__PURE__*/_react.default.createElement(MapTokenCollapseContent, {
        mapTokens: groupedTokens[key],
        theme: theme,
        selectedTokens: selectedTokens,
        onTokenSelect: onTokenSelect,
        type: group.type
      }));
    }));
  }
  if (group.groups) {
    return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
      className: "token-panel-pro-grouped-map-collapse",
      defaultActiveKey: group.groups.map(function (item) {
        return item.key;
      }),
      expandIconPosition: "end",
      expandIcon: function expandIcon(_ref6) {
        var isActive = _ref6.isActive;
        return /*#__PURE__*/_react.default.createElement(_icons.CaretRightOutlined, {
          rotate: isActive ? 450 : 360,
          style: {
            fontSize: 12
          }
        });
      }
    }, group.groups.map(function (item) {
      return /*#__PURE__*/_react.default.createElement(Panel, {
        key: item.key,
        header: item.name
      }, /*#__PURE__*/_react.default.createElement(MapTokenCollapseContent, {
        mapTokens: item.mapToken,
        theme: theme,
        selectedTokens: selectedTokens,
        onTokenSelect: onTokenSelect,
        type: item.type
      }));
    }));
  }
  return /*#__PURE__*/_react.default.createElement(MapTokenCollapseContent, {
    mapTokens: (_group$mapToken2 = group.mapToken) !== null && _group$mapToken2 !== void 0 ? _group$mapToken2 : [],
    theme: theme,
    selectedTokens: selectedTokens,
    onTokenSelect: onTokenSelect,
    type: group.type
  });
};
var groupMapToken = function groupMapToken(token) {
  if (token.startsWith('colorFill')) {
    return 'fill';
  }
  if (token.startsWith('colorBorder') || token.startsWith('colorSplit')) {
    return 'border';
  }
  if (token.startsWith('colorBg')) {
    return 'background';
  }
  if (token.startsWith('colorText')) {
    return 'text';
  }
  return '';
};
var TokenContent = function TokenContent(_ref7) {
  var id = _ref7.id,
    category = _ref7.category,
    theme = _ref7.theme,
    selectedTokens = _ref7.selectedTokens,
    onTokenSelect = _ref7.onTokenSelect,
    infoFollowPrimary = _ref7.infoFollowPrimary,
    onInfoFollowPrimaryChange = _ref7.onInfoFollowPrimaryChange;
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    grouped = _useState4[0],
    setGrouped = _useState4[1];
  var locale = (0, _locale.useLocale)();
  var advanced = (0, _context.useAdvanced)();
  var _antdTheme$useToken = _antd.theme.useToken(),
    token = _antdTheme$useToken.token;
  var switchAlgorithm = function switchAlgorithm(themeStr) {
    return function () {
      var _theme$onThemeChange2;
      var newAlgorithm = theme.config.algorithm;
      if (!newAlgorithm) {
        newAlgorithm = _useControlledTheme.themeMap[themeStr];
      } else if (Array.isArray(newAlgorithm)) {
        newAlgorithm = newAlgorithm.includes(_useControlledTheme.themeMap[themeStr]) ? newAlgorithm.filter(function (item) {
          return item !== _useControlledTheme.themeMap[themeStr];
        }) : [].concat((0, _toConsumableArray2.default)(newAlgorithm), [_useControlledTheme.themeMap[themeStr]]);
      } else {
        newAlgorithm = newAlgorithm === _useControlledTheme.themeMap[themeStr] ? undefined : [newAlgorithm, _useControlledTheme.themeMap[themeStr]];
      }
      (_theme$onThemeChange2 = theme.onThemeChange) === null || _theme$onThemeChange2 === void 0 || _theme$onThemeChange2.call(theme, _objectSpread(_objectSpread({}, theme.config), {}, {
        algorithm: newAlgorithm
      }), ['config', 'algorithm']);
    };
  };
  var isLeftChecked = function isLeftChecked(str) {
    if (!theme.config.algorithm) {
      return true;
    }
    return Array.isArray(theme.config.algorithm) ? !theme.config.algorithm.includes(_useControlledTheme.themeMap[str]) : theme.config.algorithm !== _useControlledTheme.themeMap[str];
  };
  return wrapSSR( /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(hashId, 'token-panel-pro-color'),
    id: id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-color-seeds"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-color-themes"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginRight: 12
    }
  }, locale._lang === 'zh-CN' ? category.name : category.nameEn), category.nameEn === 'Color' && /*#__PURE__*/_react.default.createElement(_antd.Segmented, {
    options: [{
      icon: /*#__PURE__*/_react.default.createElement(_icons2.Light, {
        style: {
          fontSize: 16
        }
      }),
      value: 'light'
    }, {
      icon: /*#__PURE__*/_react.default.createElement(_icons2.DarkTheme, {
        style: {
          fontSize: 16
        }
      }),
      value: 'dark'
    }],
    onChange: switchAlgorithm('dark'),
    value: isLeftChecked('dark') ? 'light' : 'dark',
    style: {
      marginLeft: 'auto'
    }
  }), category.nameEn === 'Size' && /*#__PURE__*/_react.default.createElement(_antd.Segmented, {
    options: [{
      icon: /*#__PURE__*/_react.default.createElement(_icons.ExpandOutlined, {
        style: {
          fontSize: 13,
          marginTop: 1
        }
      }),
      value: 'normal'
    }, {
      icon: /*#__PURE__*/_react.default.createElement(_icons2.CompactTheme, {
        style: {
          fontSize: 16
        }
      }),
      value: 'compact'
    }],
    onChange: switchAlgorithm('compact'),
    value: isLeftChecked('compact') ? 'normal' : 'compact',
    style: {
      marginLeft: 'auto'
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: {
      components: {
        Collapse: {
          colorBorder: token.colorSplit
        }
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-token-list"
  }, category.groups.map(function (group) {
    var _group$seedToken, _group$seedToken2, _group$seedToken3, _group$mapToken3;
    var groupDesc = locale._lang === 'zh-CN' ? group.desc : group.descEn;
    return (!!group.seedToken || advanced) && /*#__PURE__*/_react.default.createElement("div", {
      className: "token-panel-pro-token-item",
      key: group.key
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "token-panel-pro-token-item-seed"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "token-panel-pro-token-item-header"
    }, /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
      mouseEnterDelay: 0.5,
      placement: "right",
      arrow: {
        pointAtCenter: true
      },
      title: groupDesc
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "token-panel-pro-token-item-header-title"
    }, /*#__PURE__*/_react.default.createElement("span", null, locale._lang === 'zh-CN' ? group.name : group.nameEn))), ((_group$seedToken = group.seedToken) === null || _group$seedToken === void 0 ? void 0 : _group$seedToken[0]) === 'colorInfo' && /*#__PURE__*/_react.default.createElement("div", {
      key: group.seedToken[0],
      className: "token-panel-pro-token-item-header-follow-primary"
    }, /*#__PURE__*/_react.default.createElement("span", null, locale.followPrimary), /*#__PURE__*/_react.default.createElement(_antd.Switch, {
      size: "small",
      style: {
        marginLeft: 8
      },
      checked: infoFollowPrimary,
      onChange: function onChange(e) {
        return onInfoFollowPrimaryChange === null || onInfoFollowPrimaryChange === void 0 ? void 0 : onInfoFollowPrimaryChange(e);
      }
    }))), (_group$seedToken2 = group.seedToken) === null || _group$seedToken2 === void 0 ? void 0 : _group$seedToken2.map(function (seedToken) {
      var _seedToken, _theme$config$token2, _seedToken2, _theme$config$token3;
      var multipleSeeds = group.seedToken && group.seedToken.length > 1;
      return (seedToken !== 'colorInfo' || !infoFollowPrimary) && /*#__PURE__*/_react.default.createElement("div", {
        key: seedToken,
        className: "token-panel-pro-token-list-seed-block"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginRight: 'auto'
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
        mouseEnterDelay: 0.5,
        placement: "right",
        title: (_seedToken = _tokenMeta.default.global[seedToken]) === null || _seedToken === void 0 ? void 0 : _seedToken[locale._lang === 'zh-CN' ? 'desc' : 'descEn']
      }, /*#__PURE__*/_react.default.createElement("span", null, multipleSeeds && /*#__PURE__*/_react.default.createElement("span", {
        className: "token-panel-pro-token-list-seed-block-name-cn",
        style: {
          marginRight: 4,
          color: !!((_theme$config$token2 = theme.config.token) !== null && _theme$config$token2 !== void 0 && _theme$config$token2[seedToken]) ? _constants.HIGHLIGHT_COLOR : ''
        }
      }, (_seedToken2 = _tokenMeta.default.global[seedToken]) === null || _seedToken2 === void 0 ? void 0 : _seedToken2[locale._lang === 'zh-CN' ? 'name' : 'nameEn']), /*#__PURE__*/_react.default.createElement("span", {
        className: multipleSeeds ? 'token-panel-pro-token-list-seed-block-subtitle' : 'token-panel-pro-token-list-seed-block-name-cn',
        style: {
          color: !!((_theme$config$token3 = theme.config.token) !== null && _theme$config$token3 !== void 0 && _theme$config$token3[seedToken]) ? _constants.HIGHLIGHT_COLOR : ''
        }
      }, seedToken))), /*#__PURE__*/_react.default.createElement(_ResetTokenButton.default, {
        theme: theme,
        tokenName: seedToken,
        style: {
          marginLeft: 8
        }
      })))), /*#__PURE__*/_react.default.createElement(SeedTokenPreview, {
        theme: theme,
        tokenName: seedToken,
        disabled: seedToken === 'colorInfo' && infoFollowPrimary
      }));
    })), (group.mapToken || group.groups) && advanced && (!((_group$seedToken3 = group.seedToken) !== null && _group$seedToken3 !== void 0 && _group$seedToken3.includes('colorInfo')) || !infoFollowPrimary) && /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
      bordered: false,
      expandIcon: function expandIcon(_ref8) {
        var isActive = _ref8.isActive;
        return /*#__PURE__*/_react.default.createElement(_icons.CaretRightOutlined, {
          rotate: isActive ? 90 : 0
        });
      },
      style: {
        width: '100%',
        marginBlockStart: 10
      },
      className: "token-panel-pro-token-list-map-collapse"
    }, /*#__PURE__*/_react.default.createElement(Panel, {
      header: /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: (_group$mapToken3 = group.mapToken) !== null && _group$mapToken3 !== void 0 && _group$mapToken3.some(function (t) {
            var _theme$config$token4;
            return !!((_theme$config$token4 = theme.config.token) !== null && _theme$config$token4 !== void 0 && _theme$config$token4[t]);
          }) ? _constants.HIGHLIGHT_COLOR : ''
        }
      }, locale._lang === 'zh-CN' ? '梯度变量 Map Token' : 'Map Token'), group.mapTokenGroups && /*#__PURE__*/_react.default.createElement("div", {
        className: "token-panel-pro-token-list-map-collapse-grouped",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        style: {
          marginRight: 4
        }
      }, locale.groupView), /*#__PURE__*/_react.default.createElement(_antd.Switch, {
        checked: grouped,
        onChange: function onChange(v) {
          return setGrouped(v);
        },
        size: "small"
      }))),
      key: group.key
    }, /*#__PURE__*/_react.default.createElement(MapTokenCollapse, {
      group: group,
      theme: theme,
      selectedTokens: selectedTokens,
      onTokenSelect: onTokenSelect,
      groupFn: group.mapTokenGroups && grouped ? groupMapToken : undefined
    }))));
  }))))));
};
var _default = exports.default = TokenContent;